import React from "react";
import { Avatar, Tag, Text } from "@flixbus/honeycomb-react";
import { Icon, IconSpark } from "@flixbus/honeycomb-icons-react";
import styles from "./ChatHeader.module.scss";

/** Panel-header content for the AI chat: sparkle avatar + "TrackWise" name +
 *  an "AI Cost Assistant" pill. Passed as children to Honeycomb's PanelHeader
 *  (which supplies the close button). Any live status shows in the thread, never
 *  here. */
const ChatHeader: React.FC = () => (
  <span className={styles.header}>
    <Avatar extraClasses={styles.headerAvatar} size={6}>
      <Icon InlineIcon={IconSpark} size="cover" aria-hidden="true" />
    </Avatar>
    <Text Elem="span" extraClasses={styles.headerTitle}>
      TrackWise
    </Text>
    <Tag
      display="subtle"
      small
      tagColor="var(--hcr-grayscale-30-color)"
      tagTextColor="var(--hcr-content-secondary-color)"
    >
      AI Cost Assistant
    </Tag>
  </span>
);

export default React.memo(ChatHeader);
